import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";

@Component({
  selector: 'app-product-lead-popup',
  templateUrl: './product-lead-popup.component.html',
  styleUrls: ['./product-lead-popup.component.css']
})
export class ProductLeadPopupComponent implements OnInit {

  agentInfo;
  constructor(
    public activeModal: NgbActiveModal,
    private baseInfoService:EmiBaseInfoService,
  ) { 
    baseInfoService.pageDataFetched$.subscribe(
      data => {
        this.getPageData();
      });
  }

  ngOnInit() {
    this.getPageData();
  }
    getPageData(){
    try {
      if(localStorage.getItem(emiGlobals.agentInfo)&&localStorage.getItem(emiGlobals.agentInfo)!=undefined){
        this.agentInfo = JSON.parse(localStorage.getItem(emiGlobals.agentInfo));
      }
    } catch (error) {
      console.log(error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/products/product-lead-popup/product-lead-popup.component.ts